// extracted by mini-css-extract-plugin
export default {"section":"HHVb5zXOEJxW0kwGuGkT"};